// User Feedback List Component
export default {
  // Page Title
  title: "User Feedback List",

  // Search and Filter
  usernamePlaceholder: "Please enter username",
  selectTypePlaceholder: "Please select type",
  reset: "Reset",
  search: "Search",

  // Statistics and Loading
  totalRecords: "Total",
  records: "records",
  loading: "Loading...",

  // Table Columns
  username: "Username",
  phoneNumber: "Phone Number",
  email: "Email",
  type: "Type",
  content: "Content",
  createTime: "Create Time",
  remark: "Remark",
  view: "View",

  // Actions
  detail: "Detail",

  // Feedback Types
  all: "All",
  problemFeedback: "Problem Feedback",
  featureSuggestion: "Feature Suggestion",
  caseAssistance: "Case Assistance",

  // Remarks
  addRemark: "Click to add remark",
  remarkSuccess: "Remark updated successfully",

  // Detail Fields
  userId: "User ID:",
  contactInfo: "Contact:",
  emailLabel: "Email:",
  createTimeLabel: "Create Time:",
  contentLabel: "Content:",
};
